var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJumpArrow = function SvgJumpArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.484 1.633a.626.626 0 0 1 .883.052l4.355 4.9.01.015a.6.6 0 0 1 .133.284q.006.03.01.06a.6.6 0 0 1 0 .12l-.009.048a.6.6 0 0 1-.137.293l-.007.01-4.356 4.9a.626.626 0 0 1-.934-.83l3.986-4.486-3.985-4.483a.626.626 0 0 1 .051-.883"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEDCC5",
    d: "M4.484 1.633a.626.626 0 0 1 .883.052l4.355 4.9.01.015a.6.6 0 0 1 .133.284q.006.03.01.06a.6.6 0 0 1 0 .12l-.009.048a.6.6 0 0 1-.137.293l-.007.01-4.356 4.9a.626.626 0 0 1-.934-.83l3.986-4.486-3.985-4.483a.626.626 0 0 1 .051-.883"
  })));
};
export default SvgJumpArrow;